<div class="sample-info">
  <h3>Rad sa uzorcima i nalazima</h3>
  <ul>
    <li>Uzorkovanje krvnih grupa: 07:30 - 11:00</li>
    <li>Izdavanje nalaza krvnih grupa: 13:00 - 14:00</li>
    <li>Uzorkovanje HLA uzoraka: 08:00 - 12:00</li>
    <li>Izdavanje nalaza HLA: 08:00 - 12:00</li>
    <li>Trudnice - uzorkovanje: ponedjeljak i četvrtak 07:30 - 10:00</li>
    <li>Trudnice - izdavanje nalaza: srijeda i ponedjeljak 13:00 - 14:30</li>
  </ul>
</div>